import { ENDPOINTS } from "../services/Endpoints";
import { i18n } from "../main";
export default {
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      storeIdValue: null,
      comissoes: [
        { text: "7.4%", value: "7.4" },
        { text: "9.2%", value: "9.2" },
        { text: "15%", value: "15" },
        { text: "25%", value: "25" },
        { text: "Regra Personalizada", value: "personalizada" },
      ],
      headersImgs: [
        {
          title: "Imagem",
        },
        {
          title: "Url",
        },
        {
          title: "Ações",
        },
      ],
      headersDocs: [
        {
          title: "Documento",
        },
        {
          title: "Url",
        },
        {
          title: "Ações",
        },
      ],
      headersContratos: [
        {
          title: "Data de Assinatura",
        },
        {
          title: "Template",
        },
        {
          title: "Vigência",
        },
        {
          title: "Status",
        },
        {
          title: "Ações",
        },
      ],
      headersPoliticas: [
        {
          title: "Descrição",
        },
        {
          title: "Ações",
        },
      ],
    };
  },
  computed: {
    headersPerguntas() {
      return [
        {
          title: i18n.t("registrations.producers.order"),
        },
        {
          title: i18n.t("registrations.producers.question"),
        },
        {
          title: i18n.t("registrations.producers.answer"),
        },
        {
          title: i18n.t("registrations.actions"),
        },
      ];
    },
    headersRedesSociais() {
      return [
        {
          title: i18n.t("registrations.producers.order"),
        },
        {
          title: i18n.t("registrations.producers.description"),
        },
        {
          title: "Link",
        },
        {
          title: i18n.t("registrations.actions"),
        },
      ];
    },
    headersContato() {
      return [
        {
          title: i18n.t("registrations.producers.order"),
        },
        {
          title: i18n.t("registrations.producers.description"),
        },
        {
          title: i18n.t("registrations.producers.text"),
        },
        {
          title: i18n.t("registrations.actions"),
        },
      ];
    },
    status() {
      return [
        { text: i18n.t("registrations.active"), value: "ATIVO" },
        { text: i18n.t("registrations.inactive"), value: "INATIVO" },
        {
          text: i18n.t("registrations.producers.pending-terms"),
          value: "PEND_TERMOS",
        },
        {
          text: i18n.t("registrations.producers.pre-store"),
          value: "PRE_LOJA",
        },
        { text: i18n.t("registrations.producers.publish"), value: "PUBLICAR" },
        {
          text: i18n.t("registrations.producers.i-want-to-sell"),
          value: "QUERO_VENDER",
        },
      ];
    },
    pessoa() {
      return [
        {
          text: i18n.t("registrations.producers.natural-person"),
          value: "FISICA",
        },
        {
          text: i18n.t("registrations.producers.legal-person"),
          value: "JURIDICA",
        },
      ];
    },
    isAdmin() {
      if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin")
        return true;
      return false;
    },
    isRegister() {
      if (this.$route.params.type === "cadastrar") return true;
      return false;
    },
    typePerson() {
      if (this.$loja_gerenciar.cadastro.dados_cadastrais.pessoa === "FISICA")
        return true;
      return false;
    },
    pfDocsIsEmpty() {
      if (
        this.$loja_gerenciar.cadastro.documentos.documento_array_pf.length === 0
      )
        return true;
      return false;
    },
    pjDocsIsEmpty() {
      if (
        this.$loja_gerenciar.cadastro.documentos.documento_array_pj.length === 0
      )
        return true;
      return false;
    },
    getStoreId() {
      if (!this.isRegister) {
        return this.$route.params.id;
      } else {
        if (this.typePerson) {
          if (this.pfDocsIsEmpty) return null;
          return this.storeIdValue;
        } else {
          if (this.pjDocsIsEmpty) return null;
          return this.storeIdValue;
        }
      }
    },
  },
  methods: {
    goToLojas(type, idloja, sequenciador) {
      if (!this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin")
        return;
      this.$loja_gerenciar.lojaAddOrEdit = type;
      if (type === "editar" && idloja) {
        this.$loja_gerenciar.sequenciador = sequenciador;
        // this.$axios.rota(
        //   "/lojas/gerenciar/editar/aba/" + idloja + "?loja=" + sequenciador
        // );
        this.$router.push({
          name: "producersSettings",
          params: {
            type: "editar",
            aba: 1,
            id: idloja,
            sequenciador: sequenciador,
          },
        });
        return;
      }

      this.$router.push({
        name: "producersSettings",
        params: {
          type: "cadastrar",
          aba: "aba",
          id: 1,
        },
      });

      // this.$axios.rota("/lojas/gerenciar/cadastrar/aba/1");
    },
    getImagem(file, imagem) {
      const self = this;
      if (file) {
        var reader = new FileReader();
        reader?.readAsDataURL(file);

        reader.onload = function () {
          switch (imagem) {
            case "logotipo":
              self.$loja_gerenciar.cadastro.tema.logotipo.imagem =
                reader.result;
              break;
            case "logotipo_ingresso":
              self.$loja_gerenciar.cadastro.tema.logotipo_ingresso.imagem =
                reader.result;
              break;
            case "banner":
              self.$loja_gerenciar.cadastro.tema.imagem_upload.imagem =
                reader.result;
              break;
            case "logotipo_pos":
              self.$loja_gerenciar.cadastro.tema.logotipo_pos.imagem =
                reader.result;
              break;
            default:
              self.$loja_gerenciar.cadastro.tema.imagem_upload.imagem =
                reader.result;
              break;
          }
        };
        reader.onerror = function (error) {
          console.log("Error: ", error);
        };
      }
    },
    uploadImage(file, object) {
      if (object.size > 2000000) {
        this.$config.alert(
          i18n.t("registrations.producers.image-max-size-error"),
          this.$config.dados.errorColor
        );
        return;
      }
      if (this.$loja_gerenciar.cadastro.tema.imagem == "") {
        this.$config.alert(
          i18n.t("registrations.producers.image-type-error"),
          this.$config.dados.errorColor
        );
        this.$loja_gerenciar.cadastro.tema.error.imagem = i18n.t(
          "registrations.producers.image-type-error"
        );
        return;
      }

      this.$loja_gerenciar.cadastro.tema.loading_imagem = true;
      this.$axios
        .post(this.ENDPOINTS.UPLOAD_BANNER_LOJA, {
          img_base64: file,
          idtema:
            this.$loja_gerenciar.lojaAddOrEdit == "new" &&
            this.$loja_gerenciar.cadastro.tema.banners_array.length == 0
              ? ""
              : this.$produtos_gerenciar.cadastro.id_tema,
          loja: this.$axios.getLocal("oe_user_info")?.data?.loja || null,
        })
        .then(response => {
          if (response) {
            let object = {};

            if (
              this.$loja_gerenciar.lojaAddOrEdit == "new" &&
              this.$loja_gerenciar.cadastro.tema.banners_array.length == 0
            ) {
              this.$loja_gerenciar.cadastro.idtema = response.idtema;
            }
            object[this.$loja_gerenciar.cadastro.tema.imagem] = response.url;
            this.$loja_gerenciar.cadastro.tema.banners_array.push(object);
            this.$loja_gerenciar.cadastro.tema.loading_imagem = false;

            (this.$loja_gerenciar.cadastro.tema.imagem = ""),
              (this.$loja_gerenciar.cadastro.tema.imagem_upload.imagem = null);
            delete this.$loja_gerenciar.cadastro.tema.imagem_upload.object;
          }
        })
        .catch(error => {
          this.$loja_gerenciar.cadastro.tema.loading_imagem = false;
          throw new Error(error);
        });
    },
    previewImage(imagem) {
      document.getElementsByClassName(
        "modal-body-visualizar-imagem"
      )[0].style.display = "flex";
      this.$loja_gerenciar.visualizarImagem = imagem;
    },
    clearImage() {
      this.$loja_gerenciar.cadastro.tema.imagem_upload.imagem = null;
    },
    removerImagem(imagem) {
      switch (imagem) {
        case "logotipo":
          this.$loja_gerenciar.cadastro.tema.logotipo.imagem = null;
          delete this.$loja_gerenciar.cadastro.tema.logotipo.object;
          this.$loja_gerenciar.cadastro.tema.logotipo.have = false;
          break;
        case "logotipo_ingresso":
          this.$loja_gerenciar.cadastro.tema.logotipo_ingresso.imagem = null;
          delete this.$loja_gerenciar.cadastro.tema.logotipo_ingresso.object;
          this.$loja_gerenciar.cadastro.tema.logotipo_ingresso.have = false;
          break;
        case "logotipo_pos":
          this.$loja_gerenciar.cadastro.tema.logotipo_pos.imagem = null;
          delete this.$loja_gerenciar.cadastro.tema.logotipo_pos.object;
          this.$loja_gerenciar.cadastro.tema.logotipo_pos.have = false;
          break;
        default:
          this.$loja_gerenciar.cadastro.tema.logotipo.imagem = null;
          delete this.$loja_gerenciar.cadastro.tema.logotipo.object;
          this.$loja_gerenciar.cadastro.tema.logotipo.have = false;
          break;
      }
    },
    getDOC(file) {
      const self = this;
      var reader = new FileReader();
      reader.onload = e =>
        (self.$loja_gerenciar.cadastro.documentos.documento_upload.doc =
          e.target.result);
      reader.readAsDataURL(file);
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
    },
    uploadDOC(file) {
      if (this.$loja_gerenciar.cadastro.documentos.documento == "") {
        this.$config.alert(
          i18n.t("registrations.producers.document-type-error"),
          this.$config.dados.errorColor
        );
        this.$loja_gerenciar.cadastro.documentos.error.documento = i18n.t(
          "registrations.producers.document-type-error"
        );
        return;
      }

      if (
        this.$loja_gerenciar.cadastro.documentos.documento_upload.doc == null
      ) {
        this.$config.alert(
          i18n.t("registrations.producers.document-error"),
          this.$config.dados.errorColor
        );
        return;
      }

      this.$loja_gerenciar.cadastro.documentos.loading_documento = true;

      this.$axios
        .post(this.ENDPOINTS.UPLOAD_DOC_LOJA, {
          doc_base64: file,
          idloja: this.getStoreId,
          campo: this.$loja_gerenciar.cadastro.documentos.documento,
        })
        .then(response => {
          if (response) {
            let object = {};
            this.storeIdValue = response.idloja;
            this.$loja_gerenciar.cadastro.new_idloja = response.idloja;

            if (this.typePerson) {
              object[this.$loja_gerenciar.cadastro.documentos.documento] =
                response.url_s3;
              this.$loja_gerenciar.cadastro.documentos.documento_array_pf.push(
                object
              );
              this.$loja_gerenciar.cadastro.documentos.loading_documento = false;
            } else {
              object[this.$loja_gerenciar.cadastro.documentos.documento] =
                response.url_s3;
              this.$loja_gerenciar.cadastro.documentos.documento_array_pj.push(
                object
              );
              this.$loja_gerenciar.cadastro.documentos.loading_documento = false;
            }

            (this.$loja_gerenciar.cadastro.documentos.documento = ""),
              (this.$loja_gerenciar.cadastro.documentos.documento_upload.doc =
                null);
            delete this.$loja_gerenciar.cadastro.documentos.documento_upload
              .object;
          }

          this.$loja_gerenciar.cadastro.documentos.loading_documento = false;
        })
        .catch(error => {
          this.$loja_gerenciar.cadastro.documentos.loading_documento = false;
          throw new Error(error);
        });
    },
    previewDOC(doc) {
      document.getElementsByClassName(
        "modal-body-visualizar-pdf"
      )[0].style.display = "flex";
      this.$loja_gerenciar.visualizarPDF = doc;
    },
    clearDOC() {
      this.$loja_gerenciar.cadastro.documentos.documento_upload.doc = null;
    },
  },
};
